
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
// Layout
import LayoutLogged from '@/components/layouts/LayoutLogged';
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import { ManageProfilesWrapper } from '@/components/pages/socialprofiles/ManageProfilesWrapper';
// Components
import H2 from '@/components/base/Headings/H2';
import CompoundBanner from '@/components/base/InfoBanner/CompoundBanner';
import Loader from '@/components/base/Loader';
import RightPanel from '@/components/pages/socialprofiles/RightPanel';
import SocialProfilesList from '@/components/pages/socialprofiles/SocialProfilesList';
import AddSocialProfilesAction from '@/components/pages/socialprofiles/AddSocialProfilesAction';
// Hooks
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';
import useUserRole from '@/utils/hooks/user/useUserRole';
import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';
// Lib
import { SOCIAL_PROFILES_ACTION_PARAM } from '@/lib/socialprofiles/queryParams';
import useSocialProfilesAuthStatus from '@/utils/hooks/swr/useSocialProfilesAuthStatus';
function SocialProfileContent({ isOnTrial, toggleSPFunnelModal, plan }) {
    const { isAdmin, isManager } = useUserRole();
    const { isTreeStructureActivated } = useActiveTreeStructure();
    return (<>
            <SocialProfilesList isOnTrial={isOnTrial} addSocialProfile={toggleSPFunnelModal}/>
            {isAdmin || isManager ? (<div className={clsx('rounded-md bg-white xl:w-1/3', {
                'border border-icoGray-300 px-8 py-8 dark:border-icoDarkMode-beton dark:bg-icoDarkMode-deepBlack': isTreeStructureActivated,
                'rounded-bl-none rounded-br-none px-10 py-10 dark:bg-icoDarkMode-anthracite xl:-mb-m': !isTreeStructureActivated
            })}>
                    <RightPanel isAdmin={isAdmin} isManager={isManager} plan={plan}/>
                </div>) : null}
        </>);
}
const PageContent = () => {
    const { isTreeStructureActivated } = useActiveTreeStructure();
    const router = useRouter();
    const { deleteQuery } = useRouterQuery();
    const { funnel_add_social_profiles, tiktok_business_sp_id, youtube_sp_id, pinterest_sp_id } = router.query;
    const queryAction = router.query[SOCIAL_PROFILES_ACTION_PARAM.NAME];
    const { t } = useTranslation('socialprofiles');
    const [stateFunnelSocialProfiles, setStateFunnelSocialProfiles] = useState({
        isOpen: false,
        network: null,
        // For twitter & tiktok
        idSocialProfileAdded: null
    });
    // Open Funnel to add new social profiles
    useEffect(() => {
        if (!stateFunnelSocialProfiles.isOpen && funnel_add_social_profiles) {
            const getSocialProfileAddedId = () => {
                if (tiktok_business_sp_id) {
                    return parseInt(tiktok_business_sp_id);
                }
                else if (youtube_sp_id) {
                    return parseInt(youtube_sp_id);
                }
                else if (pinterest_sp_id) {
                    return parseInt(pinterest_sp_id);
                }
                else {
                    return null;
                }
            };
            setStateFunnelSocialProfiles({
                isOpen: true,
                network: funnel_add_social_profiles,
                idSocialProfileAdded: getSocialProfileAddedId()
            });
            const newUrl = deleteQuery([
                'funnel_add_social_profiles',
                'tiktok_business_sp_id',
                'youtube_sp_id',
                'pinterest_sp_id'
            ]);
            router.replace(newUrl);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [funnel_add_social_profiles]);
    useEffect(() => {
        if (queryAction === SOCIAL_PROFILES_ACTION_PARAM.VALUES.ADD_SOCIAL_PROFILES) {
            setStateFunnelSocialProfiles((prevState) => ({
                ...prevState,
                isOpen: true
            }));
        }
        const newUrl = deleteQuery(SOCIAL_PROFILES_ACTION_PARAM.NAME);
        router.replace(newUrl);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryAction]);
    const { subscription: plan, isLoading, isOnTrial, subscriptionError } = useSubscription();
    const { isLoading: isLoadingSocialProfilesAuthStatus } = useSocialProfilesAuthStatus({
        revalidateIfStale: true
    });
    if (isTreeStructureActivated) {
        return (<ManageProfilesWrapper className={clsx({ 'h-full': isLoading || isLoadingSocialProfilesAuthStatus })} header={<AddSocialProfilesAction isOpen={stateFunnelSocialProfiles.isOpen} network={stateFunnelSocialProfiles.network} idSocialProfileAdded={stateFunnelSocialProfiles.idSocialProfileAdded} setState={setStateFunnelSocialProfiles}/>}>
                {subscriptionError ? (<CompoundBanner className="mb-10">
                        <CompoundBanner.Icon />
                        <CompoundBanner.Content title={t('errors:error_occured')} message={t('errors:error_occured_fetch_data')}/>
                    </CompoundBanner>) : null}
                {isLoading || isLoadingSocialProfilesAuthStatus ? (<div className="flex h-full w-full items-center justify-center">
                        <Loader className="m-auto my-8 h-8 w-8 text-icoBlue"/>
                    </div>) : (<div className="flex w-full flex-col gap-5 @[944px]/wrapper-platform-content:flex-row">
                        <SocialProfileContent isOnTrial={isOnTrial} toggleSPFunnelModal={() => setStateFunnelSocialProfiles((prevState) => ({
                    ...prevState,
                    isOpen: !prevState.isOpen
                }))} plan={plan}/>
                    </div>)}
            </ManageProfilesWrapper>);
    }
    return (<>
            <LayoutLogged.Header className="flex flex-wrap items-center justify-between space-x-1.5 sm:space-x-2.5 md:space-x-4 lg:space-x-12">
                <H2>{t('title')}</H2>
                <AddSocialProfilesAction isOpen={stateFunnelSocialProfiles.isOpen} network={stateFunnelSocialProfiles.network} idSocialProfileAdded={stateFunnelSocialProfiles.idSocialProfileAdded} setState={setStateFunnelSocialProfiles}/>
            </LayoutLogged.Header>
            {subscriptionError ? (<CompoundBanner className="mb-12">
                    <CompoundBanner.Icon />
                    <CompoundBanner.Content title={t('errors:error_occured')} message={t('errors:error_occured_fetch_data')}/>
                </CompoundBanner>) : null}
            <div className="flex h-full w-full flex-col gap-10 lg:flex-row">
                {isLoading || isLoadingSocialProfilesAuthStatus ? (<div className="flex h-full w-full items-center justify-center">
                        <Loader className="m-auto my-8 h-8 w-8 text-icoBlue"/>
                    </div>) : (<SocialProfileContent isOnTrial={isOnTrial} toggleSPFunnelModal={() => setStateFunnelSocialProfiles((prevState) => ({
                ...prevState,
                isOpen: !prevState.isOpen
            }))} plan={plan}/>)}
            </div>
        </>);
};
const SocialProfiles = () => (<WrapperSwitchLayout>
        <PageContent />
    </WrapperSwitchLayout>);
export default SocialProfiles;

    async function __Next_Translate__getStaticProps__194b7998ca2__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/social-profiles/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__194b7998ca2__ as getStaticProps }
  